import { useTranslation } from 'react-i18next';

import { TableHead, TableHeader, TableRow } from '@/common/components/ui/table';

export const FinancialDataTableHeader = () => {
  const { t } = useTranslation();
  return (
    <TableHeader>
      <TableRow>
        <TableHead className="border-r border-warm-gray-200">
          {t('policy.financialData.description')}
        </TableHead>
        <TableHead className="border-r border-warm-gray-200 text-right">
          {t('policy.financialData.amount')}
        </TableHead>
      </TableRow>
    </TableHeader>
  );
};
